export function messageStatusLabel(message) {
  if (message.processingStatus === 'INVALIDATED') return '已失效'
  if (message.processingStatus === 'DONE') {
    if (message.eventType === 'GIFT_CLAIM_REQUIRED') return '已领取'
    if (message.eventType === 'QUESTION_REPLY_REQUIRED') return '已回复'
    return '已处理'
  }
  if (message.eventType === 'GIFT_CLAIM_REQUIRED') return '待领取'
  if (message.eventType === 'QUESTION_REPLY_REQUIRED') return '待回复'
  if (message.eventType === 'PERMISSION_REPLY_REQUIRED') return '待授权'
  if (['PLAN_CONFIRMATION_REQUIRED', 'CLINICAL_CHECKPOINT_REQUIRED'].includes(message.eventType)) return '待确认'
  return '待处理'
}

export function messageRequestHistoryNotice(message) {
  if (!message || message.target?.type !== 'SESSION_REQUEST'
    || !['QUESTION_REPLY_REQUIRED', 'PLAN_CONFIRMATION_REQUIRED', 'PERMISSION_REPLY_REQUIRED'].includes(message.eventType)
    || !['DONE', 'INVALIDATED'].includes(message.processingStatus)
    || (message.content?.body != null && typeof message.content.body !== 'string')
    || typeof (message.content?.body || message.summary) !== 'string') return ''
  return `当前状态：${messageStatusLabel(message)}。以下标题和正文为请求发起时的历史通知，当前不再等待你操作。`
}
